export const VET_RX_CONTENT_KEY = 'vet-rx-content';
